import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
    table: {
        // minWidth: 750
    }
}));
